import * as React from 'react'
import styled from "styled-components"
import { withCobrand } from '../../common/modules/cobrand'


@withCobrand
export default class Header extends React.Component<any, any>{

    render(){
        const logo = require("../images/logo.png");
        return (
            <HeaderContainer>
                <div className="container">
                    <div className="row align-items-sm-center">
                        <div className="col-12 col-sm-6 col-md-8">
                            <div className="align-items-sm-center pt-4">   
                                <img className="logo" src={ logo }/>
                                <div className="header-title header-title-inline hidden-md-down">| Residential Strata Quote</div>
                                <div className="header-title header-title-block hidden-lg-up">Residential Strata Quote</div>
                            </div>
                        </div>
                        <div className="col-12 col-sm-6 col-md-4 mt-3 mt-md-4"> 
                            { this.props.cobrand.loaded &&
                                <a href={ this.props.cobrand.url } target="_blank">
                                    <div className="hidden-md-up">
                                        <img className="cobrand-logo" src={ this.props.cobrand.logoColouredURL } />
                                    </div>
                                    <div className="text-right hidden-sm-down">
                                        <img className="cobrand-logo" src={ this.props.cobrand.logoColouredURL } />
                                    </div>
                                </a>
                            }
                        </div>
                    </div>
                </div>
            </HeaderContainer>
        )
    }

}


const HeaderContainer = styled.div`
    .email-link{
        margin-top: 21px;
    }

    .logo{
        width: auto;
    }

    .header-title{
        font-size: 20px;
        color: #006269;
        font-weight: 700;
        display: block;
        margin-left: 9px
    }

    .header-title-block{
        display:block;
        margin-left: 0px;
        margin-top: 0px;
    }

    .cobrand-logo{
        max-height: 100px;
        max-width: 200px;
        width: auto;
        height: auto;
        margin-left: -4px;
    }

    .header-title-inline{
        position: relative;
        top: 4px;
        display: inline-block;
    }

    height: auto;
    padding-top: 12px;
    padding-bottom: 32px; 
    background-color: #FFF;   

    @media (max-width: 490px) {
        .cobrand-logo, .logo{
            max-width: 70vw;
        }
    }
`



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/isaver-quote/components/isaver-quote-header.tsx